import { SubmitEvent, SubmitEventHandler } from 'react'
import { className as classNameDefault } from '@/components/common/styles'
import Panel from '@/components/common/Panel'

const Security = ({ className }: { className?: string }) => {
  // @@TODO
  const handleSecuritySettings: SubmitEventHandler = (
    e: SubmitEvent<HTMLInputElement>,
  ) => {
    e.preventDefault()
    console.log('NOT IMPLEMENTED')
  }

  return (
    <div className={`p-4 ${className}`}>
      <Panel title="Security">
        <form onSubmit={handleSecuritySettings}>
          <div className="bg-gray-50 dark:bg-gray-900 text-black dark:text-white">
            <div>
              <div className="text-lg">Password</div>
              <div className="text-sm text-gray-500 dark:text-gray-400 pb-2">
                Password was last changed on 2019-06-03 (156 days ago).
              </div>
            </div>
            <hr className="border border-dashed my-4 border-gray-200 dark:border-gray-700" />
            <div>
              <div className="text-lg">Two-factor authentication (2FA)</div>
              <div className="text-sm text-gray-500 dark:text-gray-400 pb-2">
                2FA was turned on with Authy on 2018-07-01.
              </div>
              <div className="pb-6">
                <button
                  className={`${classNameDefault} float-start`}
                  type="submit"
                  onClick={() => console.log('click button')}
                >
                  Edit two-factor authentication
                </button>
              </div>
              <br />
            </div>
            <hr className="border border-dashed my-4 border-gray-200 dark:border-gray-700" />
            <div>
              <div className="text-lg">Recovery codes</div>
              <div className="text-sm text-gray-500 dark:text-gray-400 pb-2">
                If you lose access to your two-factor authentication
                credentials, you can use your recovery codes.
              </div>
              <div className="pb-6">
                <button
                  className={`${className} float-start`}
                  type="submit"
                  onClick={() => console.log('click button')}
                >
                  Generate new recovery codes
                </button>
              </div>
              <br />
              <div className="pb-6">
                <button
                  className={`${className} float-start`}
                  type="submit"
                  onClick={() => console.log('click button')}
                >
                  Show recovery codes
                </button>
              </div>
              <br />
              <div className="pb-6">
                <button
                  className={`${className} float-start`}
                  type="submit"
                  onClick={() => console.log('click button')}
                >
                  Download recovery codes
                </button>
              </div>
              <br />
            </div>
            <div className="pb-4" />
          </div>
        </form>
      </Panel>
    </div>
  )
}

export default Security
